import React from "react"
import {
  Register as RegisterComponent
} from '../components/userActions';

const Register = () => <RegisterComponent />

export default Register
